import React, { FC } from 'react';

import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Form, Row } from 'antd';
import { Namespace, TFunction, useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import { NSKeys } from '@app/i18n';
import { SystemSlugs } from '@app/models/dictionaries';
import { DictionarySelector } from '@components/AntFields';

import { LAYOUT, TAIL_LAYOUT } from '../../constants';
import { IStep4 } from '../../interfaces';

interface IProps {
  initialValues: IStep4;
  onNext: (values: IStep4) => void;
  onPrev: () => void;
}

const ValidationSchema = (t: TFunction<Namespace<'validation'>>): Yup.SchemaOf<IStep4> =>
  Yup.object().shape({
    jobtitle: Yup.string().required(t('required')),
  });

export const Step4: FC<IProps> = (props) => {
  const [form] = Form.useForm();
  const registrationT = useTranslation(NSKeys.registration);
  const validationT = useTranslation(NSKeys.validation);
  const jobtitle = Form.useWatch('jobtitle', form);

  const yupSync = {
    async validator({ field }: any, value: any) {
      await ValidationSchema(validationT.t).validateSyncAt(field, { [field]: value });
    },
  };

  return (
    <Form
      form={form}
      name="login_form_step1"
      initialValues={props.initialValues}
      onFinish={props.onNext}
      size="large"
      {...LAYOUT}>
      <DictionarySelector
        dictionaryName={SystemSlugs.JobTitles}
        required
        name="jobtitle"
        withToken={false}
        rules={[yupSync]}
        label={registrationT.t('form.role')}
        placeholder={registrationT.t('form.rolePlaceholder')}
      />

      <Form.Item {...TAIL_LAYOUT}>
        <Row justify="space-between">
          <Button icon={<ArrowLeftOutlined />} disabled={jobtitle === ''} onClick={props.onPrev}>
            {registrationT.t('btnBack')}
          </Button>
          <Button type="primary" htmlType="submit">
            {registrationT.t('btnNext')}
          </Button>
        </Row>
      </Form.Item>
    </Form>
  );
};
